import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { bootstrapSessionFromLocal, getStoredToken, rememberPostLoginRedirect } from "./utils/authStorage";

const PrivateRoute: React.FC = () => {
  bootstrapSessionFromLocal();
  const token = getStoredToken();
  const isAuthPage = window.location.pathname === "/" || window.location.pathname === "/mobileverification";
  const location = useLocation();
  const storedRole = sessionStorage.getItem('user_role') || localStorage.getItem('user_role');

  // If on auth page and has token, redirect to home
  if (isAuthPage && token) {
    return <Navigate to={storedRole === 'admin' ? "/admin" : "/home"} replace />;
  }

  // If not on auth page and no token, redirect to login
  if (!isAuthPage && !token) {
    rememberPostLoginRedirect(location.pathname + location.search);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Otherwise, render the protected route
  return <Outlet />;
};

export { PrivateRoute };
